// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"535":"05cba151","878":"05cba151"}[chunkId] + ".chunk.css";
};